import React from 'react';
import "./AboutContentStyles.css";
import TechCarousel from './TechCarousel';
import Reveal from './Reveal';

const AboutContent = () => {
  return (
    <>
      <Reveal as="div" className="tech-carousel-wrapper">
        <TechCarousel />
      </Reveal>

      <div className='about'>
        <Reveal as="div" className='left' delay={80}>
          <p>Analista en Sistemas (Instituto Leibnitz), full-stack de punta a punta: frontend, backend, tiempo real y datos. Trabajo en equipo con metodologías ágiles, y no dejo un proyecto a medias hasta que funciona de verdad.</p>
          <a href="#contacto"><button className='btn'>Contacto</button></a>
        </Reveal>
      </div>
    </>
  );
};

export default AboutContent;
